import React, { useState } from 'react';
import './NewsActivities.css';

// Import images
import gytiImage from '../assets/GYTI_2014.jpg';
import insaImage from '../assets/INSA.jpg';
import silkVascularImage from '../assets/Silk_vascular.jpg';
import ganashaktiImage from '../assets/Ganashakti.jpg';
import termis2016Image from '../assets/TERMIS_2016.jpg';
import robertLangerImage from '../assets/Prof._Robert_Langer.jpg';
import davidKaplanImage from '../assets/Prof._David_Kaplan.jpg';
import termisImage from '../assets/TERMIS.jpg';
import nasiAwardImage from '../assets/NASI_Award.jpg';
import ncrabmImage from '../assets/NCRABM_NEHU.jpg';
import banthiaImage from '../assets/Prof._Banthia.jpg';
import gifuImage from '../assets/GIFU.jpg';
import philipImage from '../assets/Philip_Reardon.jpg';
import labImage from '../assets/Lab.jpg';
import integrativeBiologyImage from '../assets/Integrative_biology.png';
import apstImage from '../assets/APST_CONF_2015.jpg';
import workshopImage from '../assets/WORKSHOP_2015.jpg';
import silkConferenceImage from '../assets/Silk_conference_shanghai_2014.jpg';
import ashutoshDefenseImage from '../assets/Ashutosh_PhD_Defense.jpeg';
import bibritaDefenseImage from '../assets/Bibrita_PhD_Defense.jpeg';
// import chitraBiomaterialsImage from '../assets/Chitra_Biomaterials_TAM.jpeg';
import kodieswaranImage from '../assets/Kodieswaran_ACS_Nanospray.jpeg';
import chitraDefenseImage from '../assets/Chitra_PhD_Defense.jpeg';
import chitraDefensePhdImage from '../assets/20.jpeg';
import souradeepBiomaterialsImage from '../assets/Sd.png';
import rajatBiomaterialsImage from '../assets/Rajat.jpeg';
import RajatA from "../assets/RajatA.jpeg";
import VictoriaA from "../assets/VictoriaA.jpeg";
import MaheshA from "../assets/MaheshA.jpg";
import FNASc from "../assets/FNASc.jpeg";
import KodiB from "../assets/KodiB.jpg"

const NewsAndActivities = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const allNews = [
    // ─── 2026 ───
    {
      id: 43,
      date: '2026',
      title: "Kodieswaran's Publication in Biomaterials - Biocatalytic Dual Oxygen Spray to accelerate chronic wound healing",
      category: 'students',
      description: 'Accepted manuscript for work on Dual Oxygen Spray for accelerating chronic wound healing',
      type: 'publication',
      importance: 'high',
      image: KodiB
    },
    {
      id: 43,
      date: '2026',
      title: "Prof. Biman B. Mandal Elected as Fellow of NASI",
      category: 'awards',
      description: 'Heartiest congratulations to Prof. Biman B. Mandal for being elected as a Fellow of The National Academy of Sciences, India (NASI).',
      type: 'award',
      importance: 'high',
      image: FNASc
    },
    {
      id: 43,
      date: '2026',
      title: "Rajat's Best Oral Presentation Award",
      category: 'students',
      description: 'Congratulations to Rajat for receiving the ACS Best Oral Presentation Award in TRANSMATTER 2026 held at IIT Kharagpur.',
      type: 'student_achievement',
      importance: 'high',
      image: RajatA
    },
    {
      id: 43,
      date: '2026',
      title: "Victoria's Best Poster Presentation Award",
      category: 'students',
      description: 'Congratulations to Victoria for receiving the ACS Best Poster Presentation Award in TRANSMATTER 2026 held at IIT Kharagpur.',
      type: 'student_achievement',
      importance: 'high',
      image: VictoriaA
    },
    {
      id: 43,
      date: '2026',
      title: "Chevella Maheshwari's First Publication in Small Journal",
      category: 'students',
      description: 'Accepted manuscript for work on Dual-Drug Injectable Hydrogel in Osteoarthritic Cartilage Repair.',
      type: 'publication',
      importance: 'high',
      image: MaheshA
    },
    {
      id: 43,
      date: '2026',
      title: "Rajat's First Publication in ACS Biomaterials Science & Engineering",
      category: 'students',
      description: 'Accepted manuscript for work on engineered GelMA Microgels for Locoregional Drug Release for Oral cancer research.',
      type: 'publication',
      importance: 'high',
      image: rajatBiomaterialsImage
    },
    {
    id: 43,
    date: '2026',
    title: 'Congratulations to Dr. Souradeep Dey for Successfully Defending His Ph.D. Thesis',
    category: 'students',
    description: 'Congratulations to Dr. Souradeep Dey on successfully defending the Ph.D. thesis.',
    type: 'student_achievement',
    importance: 'high',
    image: souradeepBiomaterialsImage
    },
   {
    id: 34,
    date: '2026',
    title: 'Congratulations to Dr. Chitra Jaiswal for Successfully Defending Her Ph.D. Thesis',
    category: 'students',
    description: 'Congratulations to Dr. Chitra Jaiswal on successfully defending the Ph.D. thesis.',
    type: 'student_achievement',
    importance: 'high',
    image: chitraDefensePhdImage
    },
    {
      id: 35,
      date: '2026',
      title: "Chitra's Research Published in Biomaterials - Osteosarcoma TAM Reprogramming",
      category: 'students',
      description: 'Accepted manuscript for work on osteosarcoma-on-chip model to study TAM reprogramming for immunotherapeutic research.',
      type: 'publication',
      importance: 'high',
      image: chitraDefenseImage,
      link: 'https://doi.org/10.1016/j.biomaterials.2025.123917',
    },
    {
      id: 36,
      date: '2026',
      title: "Kodieswaran's First Publication in ACS Applied Materials & Interfaces",
      category: 'students',
      description: 'Accepted manuscript for work on instant nanospray bandage for wound healing research.',
      type: 'publication',
      importance: 'high',
      image: kodieswaranImage,
      link: 'https://doi.org/10.1021/acsami.5c15025'
    },
    {
      id: 37,
      date: '2026',
      title: 'Prof. Biman B. Mandal Elected as Fellow of SBAOI',
      category: 'awards',
      description: 'Heartiest Congratulations to Prof. Biman B. Mandal for being elected as a Fellow of the Society for Biomaterials and Artificial Organs, India (SBAOI), recognizing his significant contributions in the field of biomaterials and artificial organs.',
      type: 'award',
      importance: 'high'
    },
    {
      id: 38,
      date: '2026',
      title: "Souradeep's Research Publication in Biomaterials",
      category: 'students',
      description: 'Accepted manuscript for work on 3D bioprinted human osteochondral microphysiological system.',
      type: 'publication',
      importance: 'high',
      link: 'https://doi.org/10.1016/j.biomaterials.2025.123719'
    },
    {
      id: 39,
      date: '2026',
      title: "Chitra's Publication in Biomaterials - 3D Bioprinted Osteosarcoma-on-Chip",
      category: 'students',
      description: 'Accepted manuscript for work on 3D bioprinted osteosarcoma-on-chip model for anticancer drug screening.',
      type: 'publication',
      importance: 'high'
    },
    {
      id: 40,
      date: '2026',
      title: 'Lab Recognized as "CENTRE FOR ADVANCED RESEARCH" (CAR) by ICMR',
      category: 'lab_updates',
      description: 'Biomaterials & Tissue Engineering Lab officially recognized as Centre for Advanced Research by ICMR, Government of India with major funding support.',
      type: 'lab_recognition',
      importance: 'high'
    },
    // ─── 2025 ───
{
  id: 41,
  date: '2025',
  title: 'Congratulations to Dr. Ashutosh Bandyopadhyay for Successfully Defending His Ph.D. Thesis',
  category: 'students',
  description: 'Congratulations to Dr. Ashutosh Bandyopadhyay on successfully defending the Ph.D. thesis.',
  type: 'student_achievement',
  importance: 'high',
  image: ashutoshDefenseImage
},

// ID 42 - Bibrita
{
  id: 42,
  date: '2025',
  title: 'Congratulations to Dr. Bibrita Bhar for Successfully Defending Her Ph.D. Thesis',
  category: 'students',
  description: 'Congratulations to Dr. Bibrita Bhar on successfully defending the Ph.D. thesis.',
  type: 'student_achievement',
  importance: 'high',
  image: bibritaDefenseImage
},
    // ─── 2019 ───
    {
      id: 1,
      date: '2022',
      title: 'Prof. Biman B. Mandal recognized as "75 under 50 Scientists Shaping Today’s India"',
      category: 'awards',
      description: 'Recognized as one of the 75 outstanding scientists under the age of 50 shaping Today’s India by DST/Vigyan Prasar in a coffee book released by Hon. Science and Technology Minister, Govt of India.',
      type: 'award',
      importance: 'high'
    },
     {
      id: 1,
      date: '2021',
      title: 'Prof. Biman B. Mandal awarded with "S. Ramachandran NATIONAL BIOSCIENCE AWARD"',
      category: 'awards',
      description: 'Awarded with prestigious S. Ramachandran National Bioscience Award for for Career Development by the Department of Biotechnology, Govt of India. ',
      type: 'award',
      importance: 'high'
    },
    {
      id: 1,
      date: '2021',
      title: 'Prof. Biman B. Mandal awarded with "S. Ramachandran NATIONAL BIOSCIENCE AWARD"',
      category: 'awards',
      description: 'Awarded with prestigious S. Ramachandran National Bioscience Award for for Career Development by the Department of Biotechnology, Govt of India. ',
      type: 'award',
      importance: 'high'
    },
    {
      id: 1,
      date: '2021',
      title: 'Prof. Biman B. Mandal selected as "Sakura Science Exchange Program Fellow"',
      category: 'awards',
      description: 'Selected as a Fellow for the Sakura Science Exchange Program at NIMS, Japan.',
      type: 'award',
      importance: 'high'
    },
    {
      id: 2,
      date: '2020',
      title: 'Prof. Biman B. Mandal awarded with "SWARNAJAYANTI Fellowship in Life Science"',
      category: 'awards',
      description: 'Awarded with prestigious SWARNAJAYANTI Fellowship in Life Science by Department of Science and Technology, Govt of India. ',
      type: 'award',
      importance: 'high'
    },
    {
      id: 3,
      date: '2019',
      title: 'APA- Young Scientist Award 2019 by Asian Polymer Association',
      category: 'awards',
      description: 'Awarded by Asian Polymer Association, an International forum on Polymer Science and Technology.',
      type: 'award',
      importance: 'high'
    },
    {
      id: 3,
      date: '2019',
      title: '3D PRINTING WORLD AWARDS - "Innovator in Tissue Engineering of the year - Medical"',
      category: 'awards',
      description: 'International recognition for innovation in medical tissue engineering.',
      type: 'award',
      importance: 'high'
    },
    {
      id: 4,
      date: '2019',
      title: 'Congratulations to Yogendra and Prerak - ACS Applied Materials and Interfaces',
      category: 'students',
      description: 'Accepted manuscripts for work on silk based cartilage and blood vessel research. Blood vessel work highlighted in Nature India.',
      type: 'student_achievement',
      importance: 'high',
      image: silkVascularImage
    },
    {
      id: 5,
      date: '2019',
      title: "Prerak's Research Highlighted in Ganashakti Newspaper",
      category: 'students',
      description: 'Front page research highlight in Bengali daily newspaper "Ganashakti" for work on silk blood vessel.',
      type: 'media_coverage',
      importance: 'high',
      image: ganashaktiImage
    },
    {
      id: 1,
      date: '2018',
      title: 'Dr. Biman B Mandal selected for "B.M. BIRLA SCIENCE PRIZE 2018 in BIOLOGY"',
      category: 'awards',
      description: 'Recognition for outstanding contribution to biological sciences research.',
      type: 'award',
      importance: 'high'
    },
    // ─── 2016 ───
    {
      id: 6,
      date: '2016',
      title: 'Dr. Mandal and Ms. Dimple attend TERMIS-EU 2016',
      category: 'conferences',
      description: 'Attending TERMIS-EU 2016 conference at Uppsala University, Sweden.',
      type: 'conference',
      importance: 'high',
      image: termis2016Image
    },
    {
      id: 7,
      date: '2016',
      title: 'Yogendra and Dimple - BEST POSTER AWARDS at BiTERM 2016',
      category: 'students',
      description: 'Best poster awards for research presentations at BiTERM 2016 organized at IIT Delhi.',
      type: 'student_achievement',
      importance: 'medium'
    },
    {
      id: 8,
      date: '2016',
      title: 'Manishekhar - RSC Advances & Composites Science & Technology',
      category: 'students',
      description: 'Accepted manuscripts in prestigious journals for advanced materials research.',
      type: 'publication',
      importance: 'medium'
    },
    {
      id: 9,
      date: '2016',
      title: 'Lab Recognized as "UNIT OF EXCELLENCE in Biomaterial & Tissue Engineering"',
      category: 'lab_updates',
      description: 'Official recognition by DBT, Government of India with major funding support.',
      type: 'lab_recognition',
      importance: 'high'
    },
    // ─── 2015 ───
    {
      id: 10,
      date: '2015',
      title: 'Honored Meeting with Prof. Robert Langer of MIT',
      category: 'collaborations',
      description: 'Prestigious interaction with world-renowned Professor Robert Langer at TERMIS-2015 World Congress, Boston.',
      type: 'collaboration',
      importance: 'high',
      image: robertLangerImage
    },
    {
      id: 11,
      date: '2015',
      title: 'Meeting with Post Doc Mentor Prof. David Kaplan of TUFTS University',
      category: 'collaborations',
      description: 'Interaction with esteemed mentor at TERMIS-2015 World Congress, Boston.',
      type: 'collaboration',
      importance: 'high',
      image: davidKaplanImage
    },
    {
      id: 12,
      date: '2015',
      title: 'Co-Organized Special Symposium on Silk Based Tissue Engineering',
      category: 'conferences',
      description: 'Joint organization with Prof. David Kaplan (Tufts) and Dr. Xiaoqin Wang (Soochow) at TERMIS World Congress 2015, Boston.',
      type: 'conference',
      importance: 'high',
      image: termisImage
    },
    {
      id: 13,
      date: '2015',
      title: 'NASI-Young Scientist Award 2015',
      category: 'awards',
      description: 'Awarded by the National Academy of Sciences India for young scientist contributions.',
      type: 'award',
      importance: 'high',
      image: nasiAwardImage
    },
    {
      id: 14,
      date: '2015',
      title: 'NASI-SCOPUS Young Scientist Award 2016 in Medicine',
      category: 'awards',
      description: 'Prestigious award by the National Academy of Sciences India for medical research.',
      type: 'award',
      importance: 'high'
    },
    {
      id: 15,
      date: '2015',
      title: 'Chief Guest at NCRABM-2015 Conference',
      category: 'conferences',
      description: 'Honored to serve as Chief Guest at the valedictory session of National Conference on Recent Advances in Biomedical Engineering at NEHU Shillong.',
      type: 'conference',
      importance: 'medium',
      image: ncrabmImage
    },
    {
      id: 16,
      date: '2015',
      title: 'Prof. A. K. Banthia Visits Laboratory',
      category: 'collaborations',
      description: 'Respected professor from IIT Kharagpur visits our research laboratory.',
      type: 'collaboration',
      importance: 'medium',
      image: banthiaImage
    },
    {
      id: 17,
      date: '2015',
      title: 'Esteem Visitors from GIFU University Japan',
      category: 'collaborations',
      description: 'Prof. M. Shima and Prof. Y. Yoshida from GIFU University, Japan visit the laboratory.',
      type: 'collaboration',
      importance: 'medium',
      image: gifuImage
    },
    {
      id: 18,
      date: '2015',
      title: 'Dr. Philips Reardon from UCL Visits Laboratory',
      category: 'collaborations',
      description: 'Dr. Philips Reardon from University College London (UCL), UK - DST-UKIERI International collaborator on Bone Tissue Engineering project.',
      type: 'collaboration',
      importance: 'medium',
      image: philipImage
    },
    {
      id: 19,
      date: '2015',
      title: 'Lab Party at Barbeque Nation',
      category: 'lab_updates',
      description: 'Happy hours and celebration event with lab members.',
      type: 'lab_event',
      importance: 'low',
      image: labImage
    },
    {
      id: 20,
      date: '2015',
      title: 'Dr. Nandana - Cover Page Article in Integrative Biology',
      category: 'students',
      description: 'Congratulations to Dr. Nandana for accepted manuscript published as cover page article in prestigious journal.',
      type: 'publication',
      importance: 'high',
      image: integrativeBiologyImage
    },
    {
      id: 21,
      date: '2015',
      title: 'Manishekhar & Praveen - BEST POSTER AWARDS at APST-2015',
      category: 'students',
      description: 'Best poster awards at Advanced Polymer Science and Technology conference 2015.',
      type: 'student_achievement',
      importance: 'medium',
      image: apstImage
    },
    {
      id: 22,
      date: '2015',
      title: 'Workshop on Advances in Biomedical Engineering - 2015',
      category: 'conferences',
      description: 'Successfully conducted workshop bringing together researchers and professionals in the field.',
      type: 'conference',
      importance: 'medium',
      image: workshopImage
    },
    // ─── 2014 ───
    {
      id: 23,
      date: '2014',
      title: 'Shreya Cracks CSIR-NET 2014 with All India Rank 73',
      category: 'students',
      description: 'Excellent performance in CSIR-NET 2014 examination by lab member Shreya.',
      type: 'student_achievement',
      importance: 'high'
    },
    {
      id: 24,
      date: '2014',
      title: 'Dr. Rocktotpal Konwarh Joins as Institute Post Doctoral Fellow',
      category: 'lab_updates',
      description: 'Welcome and congratulations to new post doctoral fellow joining the research team.',
      type: 'lab_update',
      importance: 'low'
    },
    {
      id: 25,
      date: '2014',
      title: 'Dr. Nandana - Accepted in Macromolecular Bioscience',
      category: 'students',
      description: 'Congratulations to Dr. Nandana for manuscript acceptance in prestigious journal.',
      type: 'publication',
      importance: 'medium'
    },
    {
      id: 26,
      date: '2014',
      title: 'Manishekhar - Fulbright-Nehru Doctoral Research Fellowship 2015-16',
      category: 'students',
      description: 'Selected for Fulbright-Nehru fellowship to visit Prof. David Kaplan lab at Tufts University, USA for 9 months.',
      type: 'student_achievement',
      importance: 'high'
    },
    {
      id: 27,
      date: '2014',
      title: 'Dr. Biman B. Mandal Elected Member of National Academy of Sciences',
      category: 'awards',
      description: 'Elected as Member (M.N.A.Sc.) of National Academy of Sciences, India.',
      type: 'award',
      importance: 'high',
      image: insaImage
    },
    {
      id: 28,
      date: '2014',
      title: 'Manishekhar - Sensors and Actuators B: Chemicals Publication',
      category: 'students',
      description: 'Congratulations on accepted manuscript in prestigious journal.',
      type: 'publication',
      importance: 'medium'
    },
    {
      id: 29,
      date: '2014',
      title: 'Surojeet Selected for DuPont Power of Sunya - Quest for Zero',
      category: 'students',
      description: 'Selected among top 16 teams for science innovation program to be featured on TIMES NOW TV channel.',
      type: 'student_achievement',
      importance: 'high'
    },
    {
      id: 30,
      date: '2014',
      title: 'Surojeet Wins Gandhian Young Technological Innovation Award (GYTI-2014)',
      category: 'students',
      description: 'Won prestigious award given by Dr. R.A. Mashelkar at IIM Ahmedabad for MTech thesis on injectable silk hydrogel.',
      type: 'student_achievement',
      importance: 'high',
      image: gytiImage
    },
    {
      id: 31,
      date: '2014',
      title: 'Dr. Mandal Joins Editorial Board of Journal of Biotechnology and Bioengineering',
      category: 'lab_updates',
      description: 'Editorial board member of Journal of Biotechnology and Bioengineering.',
      type: 'lab_update',
      importance: 'low'
    },
    {
      id: 32,
      date: '2014',
      title: 'Dr. Mandal Joins Editorial Board - Multiple Journals',
      category: 'lab_updates',
      description: 'Joined as Editorial Board Member of: Advances in Genetic Engineering, Bioscience and Engineering, International Journal of Research in Engineering and Technology.',
      type: 'lab_update',
      importance: 'low'
    },
    {
      id: 33,
      date: '2014',
      title: 'International Silk Conference 2014 - Shanghai & Fudan, China',
      category: 'conferences',
      description: 'Group attendance at International Silk Conference with fellow silk research stalwarts.',
      type: 'conference',
      importance: 'medium',
      image: silkConferenceImage
    }
  ];

  const categories = [
    { id: 'all', label: 'All News', icon: '📰' },
    { id: 'awards', label: 'Awards & Recognition', icon: '🏆' },
    { id: 'students', label: 'Student Achievements', icon: '🎓' },
    { id: 'conferences', label: 'Conferences', icon: '🌍' },
    { id: 'collaborations', label: 'Collaborations', icon: '🤝' },
    { id: 'lab_updates', label: 'Lab Updates', icon: '🔬' }
  ];

  const getCategoryColor = (category) => {
    const colors = {
      awards: '#f0ad4e',
      students: '#5cb85c',
      conferences: '#5bc0de',
      collaborations: '#9b59b6',
      lab_updates: '#e74c3c'
    };
    return colors[category] || '#4e78b2';
  };

  const getImportanceBadge = (importance) => {
    const badges = {
      high: { label: 'Featured', class: 'badge-high_1' },
      medium: { label: 'Notable', class: 'badge-medium_1' },
      low: { label: 'Update', class: 'badge-low_1' }
    };
    return badges[importance] || badges.medium;
  };

  const filteredNews = activeCategory === 'all' 
    ? allNews 
    : allNews.filter(item => item.category === activeCategory);

  const featuredNews = allNews.filter(item => item.importance === 'high' && item.image).slice(0, 3);

  return (
    <div className="news-page_1">
      <div className="news-container_1">

        {/* Main News Grid Section */}
        <section className="news-grid-section_1">
          <h2 className="section-title_1">
            {activeCategory === 'all' ? 'All News & Updates' : categories.find(c => c.id === activeCategory)?.label}
          </h2>
          
          <div className="news-grid_1">
            {filteredNews.map((news) => (
              <article key={news.id} className="news-card_1">
                {/* Image Section */}
                {news.image && (
                  <div className="card-image-wrapper_1">
                    <img src={news.image} alt={news.title} className="card-image_1" />
                  </div>
                )}

                {/* Content Section */}
                <div className="card-content_1">
                  <div className="card-meta_1">
                    <span className="card-year_1">{news.date}</span>
                    <span 
                      className="card-category_1" 
                      style={{ backgroundColor: getCategoryColor(news.category) }}
                    >
                      {categories.find(c => c.id === news.category)?.icon}
                    </span>
                    <span className={`card-importance_1 ${getImportanceBadge(news.importance).class}`}>
                      {getImportanceBadge(news.importance).label}
                    </span>
                  </div>

                  <h3 className="card-title_1">{news.title}</h3>
                  
                  <p className="card-description_1">{news.description}</p>

                  <div className="card-footer_1">
                    <span className="card-type_1">
                      {news.type === 'award' && '🏆 Award'}
                      {news.type === 'student_achievement' && '🎓 Student Achievement'}
                      {news.type === 'publication' && '📝 Publication'}
                      {news.type === 'conference' && '🌍 Conference'}
                      {news.type === 'collaboration' && '🤝 Collaboration'}
                      {news.type === 'media_coverage' && '📰 Media Coverage'}
                      {news.type === 'lab_recognition' && '⭐ Lab Recognition'}
                      {news.type === 'lab_event' && '🎉 Lab Event'}
                      {news.type === 'lab_update' && '📢 Lab Update'}
                    </span>
                    {news.link && (
                      <a 
                        href={news.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="card-link_1"
                      >
                        View Publication ↗
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* No Results Message */}
          {filteredNews.length === 0 && (
            <div className="no-results_1">
              <p>No news items found in this category.</p>
            </div>
          )}
        </section>

        {/* Statistics Section */}
        <section className="statistics-section_1">
          <h2 className="section-title_1">By The Numbers</h2>
          <div className="stats-grid_1">
            <div className="stat-item_1">
              <div className="stat-icon_1">🏆</div>
              <div className="stat-number_1">{allNews.filter(n => n.category === 'awards').length}</div>
              <div className="stat-label_1">Awards & Recognition</div>
            </div>
            <div className="stat-item_1">
              <div className="stat-icon_1">🎓</div>
              <div className="stat-number_1">{allNews.filter(n => n.category === 'students').length}</div>
              <div className="stat-label_1">Student Achievements</div>
            </div>
            <div className="stat-item_1">
              <div className="stat-icon_1">🌍</div>
              <div className="stat-number_1">{allNews.filter(n => n.category === 'conferences').length}</div>
              <div className="stat-label_1">Conferences & Workshops</div>
            </div>
            <div className="stat-item_1">
              <div className="stat-icon_1">🤝</div>
              <div className="stat-number_1">{allNews.filter(n => n.category === 'collaborations').length}</div>
              <div className="stat-label_1">International Collaborations</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewsAndActivities;